import { stickInit } from "./sticky"
import { searchInit } from "./search"

export const headerInit = () => {
  stickInit()
  searchInit()
}
